import React, { Component, useContext, useState, useEffect, Fragment } from "react";
import styled, { css } from "styled-components";
import Colorer from 'color';
import { ProductContext } from "../../context";
import { relative } from "path";
import { color } from "highcharts";
import { reduce } from "highcharts";
import Bg from "../Bg";
import { orders } from './orders';
import Tap from 'react-interactions';
import Popup from "../Popup";
import { Scrollbars } from 'react-custom-scrollbars';
import { eraseCookie } from '../store/Cookie';
import { Tabs } from './Tabs';
import { UserAccountOrders } from "./UserAccountOrders";
import { UserAccountSubscriptions } from "./UserAccountSubscriptions";
import { InputM, CssLabel } from '../uikit-b2c/InputM';
import { CssImage, CssPrice, CssPaper,
  CssH1,
  CssFormGroup,
  CssPopSection,
} from "./../uikit-b2c/uikit-b2c";
import { ContentBlock } from '../uikit-b2c/uikit-b2c';


export function UserAccountRefunds() {
  const valueFromContext = useContext(ProductContext);
  return (
    <React.Fragment>
      <CssFormGroup alignment="center">
      <CssPopSection theme={valueFromContext.getTheme()}>

        <CssFormGroup indentation="lg">
          <CssH1>My refunds</CssH1>
        </CssFormGroup>


        <CssFormGroup indentation="lg">
              <CssPaper theme={valueFromContext.getTheme()}>
                <CssCols theme={valueFromContext.getTheme()}>

                  <CssLeft theme={valueFromContext.getTheme()}>
                    <CssOrderNum>
                      <CssFormGroup indentation='xs'>
                        Order ID: 3243274683628746<br/>
                        Oct 1, 2019
                      </CssFormGroup>
                    </CssOrderNum>
                  </CssLeft>


                  <CssRight>

                  </CssRight>

                </CssCols>

              </CssPaper>
        </CssFormGroup>


      <CssFormGroup alignment="center">
        <CssPopSection theme={valueFromContext.getTheme()}>


        <CssFormGroup indentation="lg">
          {/* <CssPaper theme={valueFromContext.getTheme()}> */}

          <UserAccountRefundsLine
            date = 'Oct 16, 2019'
            title = 'Refund initiated'
            active = {true}
            line = "solid"
            label = {<p>
              <b>Reason:</b><br/>
              The game doesn't work on my PC
            </p>}
            theme={valueFromContext.getTheme()}
          />

          <UserAccountRefundsLine
            date = 'Oct 17, 2019'
            title = 'Request processed'
            active = {true}
            line = "dashed"
            label = {<p>
              <b>Resolution:</b><br/>
              The request was <b>approved</b>
            </p>}
            theme={valueFromContext.getTheme()}
          />

          <UserAccountRefundsLine
            date = 'Oct 17, 2019'
            title = 'Funds return processing'
            label = {<p>
              Please wait 3 budiness days, according to processing times of your bank "Bank of America"
            </p>}
            theme={valueFromContext.getTheme()}
          />

          {/* </CssPaper> */}
        </CssFormGroup>

        </CssPopSection>
      </CssFormGroup>


      </CssPopSection>
      </CssFormGroup>
    </React.Fragment>)
}





export const UserAccountRefundsLine = ({
  theme,
  date,
  title,
  label,
  active,
  line,
}) => {
  return(

    <CssCols cols="2fr 2fr 8fr">

      <CssFormGroup indentation="lg">
        <div style={{
          paddingTop: 8,
        }}>
          {date}
        </div>
      </CssFormGroup>

      <CssRefTime0>
        <CssRefTimeO active={active} theme={theme}/>
        <CssRefTimeLine line={line ? line : 'none'} theme={theme}/>
      </CssRefTime0>


      <CssFormGroup indentation="lg">
        <CssAction active={active}>
          <CssH1>{title}</CssH1>
          {label}
        </CssAction>
      </CssFormGroup>

    </CssCols>


  )
}



export const CssCols = styled.div`
  width: 100%;
  display: ${({cols}) => Boolean(cols) ? 'grid' : 'flex'};
  grid-template-columns: ${({cols}) => !!cols ? cols : '1fr 2fr'};
  grid-column-gap: 16px;
  /* grid-row-gap: 16px; */
  /* display: flex; */
`;


export const CssLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  opacity: 0.6;
`;



export const CssOrderNum = styled.div`
  font-size: 0.9em;
`;

export const CssRight = styled.div`
  /* display: flex;
  flex-wrap: wrap; */
`;



const CssRefTime0 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 9px;
`;
const CssRefTimeO = styled.div`
  border: 1px solid ${({theme}) => Colorer(theme['colorText']).alpha(0.8).string()};
  background: ${({theme, active}) => active && Colorer(theme['colorText']).alpha(0.8).string()};
  border-radius:100px;
  width: 17px;
  height: 17px;
`;

const CssRefTimeLine = styled.div`
  border-left: 1px ${({line}) => !!line ? line : 'solid'} ${({theme}) => Colorer(theme['colorText']).alpha(0.2).string()};
  flex-grow:1;
  margin-bottom: -8px;
`;

const CssAction = styled.div`
  opacity: ${({active}) => active ? 1 : 0.6};
`;
